<template>
  <div>
    <div class="position-relative" style="border:1px solid #eee" v-if="visible">
      <!-- 요일 -->
      <div class="flex lp-days">
        <div class="lp-day"
             v-for="(day,idx) in days" :key="'day-'+idx">{{ day }}</div>
      </div>
      <div style="padding:70px 20px 0 20px;height:42vh;overflow-y:scroll">
        <!-- 일 -->
        <div v-for="(cal, cal_idx) in calendar" :key="`cal-${cal_idx}`">
          {{ cal.year }}년 {{ cal.month }}월
          <div class="flex wrap lp-dates">
            <div class="lp-date unselect position-relative"
                 v-for="(date,idx) in cal.dates"
                 :key="'date-'+idx"
                 @click="clickDate(date,idx)"
                 :style="dayWrapStyle(date)">
              <div class="flex-center" :style="dayStyle(date)">
                <!-- 일자 표시 -->
                <div class="position-absolute size-13 date-number">{{ date.day > 0 ? date.day : '' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex-between" style="padding:8px 20px;background-color:white;border-top: 1px solid #eee">
        <div>
          <div>{{ selectedDate }}</div>
          <div v-if="!btnEnable" class="color-sub size-12">최소 {{ minPeriodDate }}이상 선택해야 예약이 가능합니다</div>
        </div>
        <button class="button" :style="customStyle" @click="clickOk" style="width:100px">선택완료</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SchedulePeriodOverlay",
    props: {
      productId: {
        type: Number
      }
    },
    data() {
      return {
        "max": 1,
        "days": [
          "일",
          "월",
          "화",
          "수",
          "목",
          "금",
          "토"
        ],
        "dates": [],
        "touch": 0,
        "maximum": 1,
        "minimum": 1,
        "visible": false,
        "calendar": [],
        "end_date": "",
        "start_date": "",
        "currentDate": undefined,
        "ordered_count": 1
      }
    },
    created() {
      this.currentDate = this.moment();
      this.$axios.get(`user/0/mapping/product/${this.productId}?fields=minimum,maximum`).then(res => {
        this.minimum = res.data.minimum;
        this.maximum = res.data.maximum;
      });
      this.setDates();
    },

    methods: {
      // 선택완료
      clickOk() {
        this.$emit('selectedResv', this.period);
      },
      // 날짜 선택
      clickDate(date) {
        if(date.prev || !date.enable) {
          return;
        }
        // 선택한 날짜가 최대 선택가능한 일 수 보다 넘치는 경우

        // 선택한 날짜가 기존 날짜보다 전일 경우 예외처리
        if(this.start_date.year >= date.year && this.start_date.month >= date.month && this.start_date.day >= date.day) {
          this.touch = 1;
          this.start_date = date;
          this.end_date = date;
        }
        else if(this.calcPeriod(this.start_date, date) > this.maximum) {
          this.touch = 1;
          this.start_date = date;
          this.end_date = date;
        }
        // 1번쨰 터치할 경우
        else if(this.touch===0) {
          this.touch += 1; // touch=1
          this.start_date = date;
          this.end_date = date;
        }
        // 2번쨰 터치할 경우
        else if(this.touch===1) {
          // 같은 날짜 선택
          if(this.start_date.year === date.year && this.start_date.month === date.month && this.start_date.day === date.day) {
            this.end_date = date;
          }
          // 다른 날짜 선택
          else {
            let start = this.start_date;
            let end = date;
            let start_date = this.datesFormat(this.dateToStr(start), 'date_3');
            let end_date = this.datesFormat(this.dateToStr(end), 'date_3');

            // 기간안에 예약가능한 날짜가 없을 경우 선택한 날짜 단일 선택으로 변경
            for(let i=0; i<this.calendar.length; i++) {
              let cal = this.calendar[i];
              for(let j=0; j<cal.dates.length; j++) {
                let dates = cal.dates[j];
                let date_item = this.datesFormat(this.dateToStr(dates), 'date_3');

                if(this.moment(start_date).isBefore(date_item) && this.moment(date_item).isBefore(end_date)) {
                  if(!dates.enable) {
                    this.start_date = date;
                    this.end_date = date;
                    this.touch = 1;
                    return;
                  }
                }
              }
            }

            this.touch += 1; // touch=2
            this.end_date = date;
          }
        }
        // 3번쨰 터치할 경우
        else if(this.touch===2) {
          this.start_date = date;
          this.end_date = date;
          this.touch = 1;
        }

      },
      dateToStr(date) {
        if(date.day === '') return '';
        return '%d-%02d-%02d'.format(date.year, date.month, date.day);
      },
      formattedDate(date) {
        return this.moment(this.dateToStr(date)).format('YY.MM.DD(dd)');
      },
      btnStyle(resv) {
        let deco = {
          borderRadius: '20px',
          padding: '5px 20px',
          textAlign: 'center',
          marginBottom: '12px'
        };
        if(resv.remain === 0) {
          deco.color = 'white';
          deco.backgroundColor = '#ddd';
        }
        else {
          if(resv.selected) {
            deco.color = 'white';
            deco.backgroundColor = '#ff5722';
          } else {
            deco.color = '#ff5722';
          }
          deco.border = '1px solid #dddddd';
        }

        return deco;
      },
      dayWrapStyle(date_val) {
        // 하루만 선택된 경우
        let start = this.start_date;
        let end = this.end_date;
        let start_date = this.moment(`${start.year}-${start.month}-${start.day}`).format('YYYY-MM-DD');
        let end_date = this.moment(`${end.year}-${end.month}-${end.day}`).format('YYYY-MM-DD');
        let date = this.moment(`${date_val.year}-${date_val.month}-${date_val.day}`).format('YYYY-MM-DD');
        let deco = {};
        // 선택한 날짜 기간에 스타일 추가
        if(this.moment(start_date).isSameOrBefore(date) && this.moment(date).isSameOrBefore(end_date)) {
          // console.log(start_date, end_date)
          if (start_date === end_date) {
            deco.justifyContent = 'center'
          }
          // 선택 처음날짜
          else if(start_date === date) {
            deco.justifyContent = 'flex-end';
          }
          // 선택 마지막날짜
          else if(end_date === date) {
            deco.justifyContent = 'flex-start';
          }
        }

        return deco;
      },
      dayStyle(date_val) {
        let start = this.start_date;
        let end = this.end_date;
        let start_date = this.moment(`${start.year}-${start.month}-${start.day}`).format('YYYY-MM-DD');
        let end_date = this.moment(`${end.year}-${end.month}-${end.day}`).format('YYYY-MM-DD');
        let date = this.moment(`${date_val.year}-${date_val.month}-${date_val.day}`).format('YYYY-MM-DD');
        // prev: 현재날짜 기준 이전날짜, 다음달 날짜
        // enable: times 있을 경우 true
        let deco = {
          // borderRadius: '50%',
          color: 'white',
          width: '36px',
          height: '36px',
          lineHeight: '36px',
          // textAlign: 'center'
        };
        // 선택한 날짜 기간에 스타일 추가
        // (date.day>=this.start_date.day && date.month===this.start_date.month && date.year===this.start_date.year) &&
        // (date.day<=this.end_date.day && date.month===this.end_date.month && date.year===this.end_date.year)

        if(this.moment(start_date).isSameOrBefore(date) && this.moment(date).isSameOrBefore(end_date)) {
          deco.backgroundColor = '#ff5722';
          deco.color = 'white';
          deco.width = '100%';
          // 하루만 선택된 경우
          if (start_date === end_date) {
            deco.width  = '36px';
            deco.borderRadius = '50%';
          }
          // 선택 처음날짜
          else if(start_date === date) {
            deco.borderTopLeftRadius = '36px';
            deco.borderBottomLeftRadius = '36px';
            deco.width = 'calc(42px + ((100% - 36px) / 2))';
          }
          // 선택 마지막날짜
          else if(end_date === date) {
            deco.borderTopRightRadius = '36px';
            deco.borderBottomRightRadius = '36px';
            deco.width = 'calc(42px + ((100% - 36px) / 2))';
          }

        }
        else {
          deco.color = '#515151';
          // deco.border = '1px solid #dddddd';
          deco.lineHeight = '35px';
        }
        // 이전날짜 비활성화 표시
        if(date_val.prev) {
          // deco.border = '1px solid #dddddd';
          deco.color = '#e4dde4';
          deco.lineHeight = '35px';
        }
        else if(!date_val.enable) {
          deco.color = '#e4dde4';
        }

        return deco;
      },
      async setDates() {
        let currentDate = this.currentDate;
        for (let x=0; x<6; x++) {
          this.dates = [];
          let day = 0;
          if(x>0) {
            currentDate = currentDate.add(1, 'month');
          }
          let year = currentDate.year();
          let month = currentDate.month()+1;
          let start_day = currentDate.startOf('month').day();
          let end_date = currentDate.endOf('month').date();
          // console.log('year,month,start_day,end_date',year,month,start_day,end_date);
          // 6주일경우 42, 5주는 35
          let len = 42;
          if(start_day + end_date <= 35) {
            len = 35;
          }

          // 이전달 날짜 (prev:true)
          for(let i=start_day-1; i>=0; i--) {
            let old = this.moment(currentDate);
            old.subtract(1, 'month');
            let old_last = old.endOf('month').date();

            if(x===0) {
              this.dates.push({
                year: old.year(),
                month: old.month()+1,
                day: old_last - i,
                prev: true
              });
            }
            else {
              this.dates.push({
                year: old.year(),
                month: old.month()+1,
                day: '',
                prev: true
              });
            }
          }

          // 현재달 날짜 (prev: 이전날짜는 prev: true)
          for(let i=0; i< len; i++) {
            // console.log('i, day, start_day, end_date', i, day, start_day, end_date)
            if(i>=start_day && day<end_date) {
              let date = {
                year: year,
                month: month,
                day: ++day,
                enable: false,
              };
              // console.log('날짜',year, month, day)
              date.prev = this.moment('%d-%02d-%02d'.format(year,month,day+1)).isBefore(this.moment());
              this.dates.push(date);
            }
          }

          let monthly = `${currentDate.year()}-${currentDate.month()+1}`;
          let url = `public/product/${this.productId}/schedule/monthly/${monthly}`;
          let res = await this.$axios.get(url);
          res.data.dates.forEach(item => {
            let current = this.dates.filter(date_item => {
              return date_item.year === item.year &&
                date_item.month === item.month &&
                date_item.day === item.day;
            })[0];

            if(current && item.day>0 && item.remain > 0) {
              current.enable = true;
            }
          });
          this.calendar.push({"year": year, "month": month, "dates": this.dates})
          if(x===5) this.visible = true;
        }
      },
      calcPeriod(start_date, end_date) {
        if(!start_date) {
          return 0;
        }
        let resv_date = this.datesFormat(this.dateToStr(start_date), 'date_4');
        let resv_end_date = this.datesFormat(this.dateToStr(end_date), 'date_4');
        return this.moment(resv_end_date).diff(this.moment(resv_date), 'days') + 1;
      }
    },
    computed: {
      minPeriodDate() {
        let date = this.minimum;
        return date>1 ? `${date-1}박 ${date}일` : `무박 ${date}일`;
        //return date>1 ? `${date-1}박` : `무박`;
      },
      selectedDate() {
        if(this.start_date === '') return '';
        let start_date = this.formattedDate(this.start_date);
        let end_date = this.formattedDate(this.end_date);

        if(start_date===end_date) {
          return start_date;
        }
        else {
          return `${start_date} - ${end_date}`;
        }
      },
      period() {
        if(this.start_date === '') {
          return {
            period: true,
            resv_date: '',
            resv_end_date: '',
            days: -1
          }
        }
        let resv_date = this.datesFormat(this.dateToStr(this.start_date), 'date_4');
        let resv_end_date = this.datesFormat(this.dateToStr(this.end_date), 'date_4');
        return {
          period: true,
          resv_date: resv_date,
          resv_end_date: resv_end_date,
          days: this.moment(resv_end_date).diff(this.moment(resv_date), 'days') + 1
        }
      },
      btnEnable() {
        return this.period.days+1 >= this.minimum;
      },
      customStyle() {
        if(this.btnEnable) {
          return {
            borderRadius: '8px',
            color: '#ffffff',
            backgroundColor: '#ff5722'
          }
        }
        else {
          return {
            borderRadius: '8px',
            color: '#ffffff',
            backgroundColor: '#eeeeee'
          }
        }
      }
    },
  }
</script>

<style lang="stylus" scoped>
  .bg-white
    background-color white
  .color-main
    color #333333
  .color-sub
    color #989898

  .size-12
    font-size 12px
  .size-14
    font-size 14px
  .lp-month
    font-size 15px
    margin 0 12px

  .lp-days
    padding 12px 0
    border-bottom 1px solid #eeeeee
    margin-bottom 12px
    position absolute
    width 96%
    background-color white
    padding 12px 22px 12px 18px


  .lp-day
    width 14.2857%
    text-align center
    padding-bottom 4px
    font-size 13px

  .lp-dates
    margin-bottom 20px

  .lp-date
    width 14.2857%
    height 14.2857%
    display flex
    justify-content center
    margin 8px 0

  .icon-arrow
    color #fff
    background-color #777
    border-radius 50%
    font-size 18px

  .box-resv
    padding 12px 0
    border-top 1px solid #ddd

  .date-number
    height 100%
    width 20px
    text-align center
    top 0
    left calc(50% - 10px)
</style>
